import React from 'react';
import {
    OrdersDateCaseContainer,
    DateCaseContainer,
} from './OrdersDateCaseHeader.styled';
import { getDisplayDate } from 'src/utils/dateUtils';
import { useTranslation } from 'react-i18next';

const OrderDateCaseHeader = ({ selectedDate, day, totalCase, isToday }) => {
    const { t } = useTranslation();
    return (
        <OrdersDateCaseContainer today={isToday}>
            {isToday && (
                <div className="today">{t('calendar.orders.todayLabel')}</div>
            )}
            <DateCaseContainer>
                <div>
                    {getDisplayDate(selectedDate)} <span>{day}</span>
                </div>
                <div className="cases">
                    {totalCase > 0
                        ? totalCase
                        : t('calendar.orders.noCasesLabel')}{' '}
                    {totalCase === 1
                        ? t('calendar.orders.caseLabel')
                        : totalCase > 0 && t('calendar.orders.casesLabel')}
                </div>
            </DateCaseContainer>
        </OrdersDateCaseContainer>
    );
};

export default OrderDateCaseHeader;
